import { styled } from '../../lib/styles';
export const CurrentTimeIndicatorStylesCurrentDay = styled.div.attrs({
  'data-test-id': 'current-time-indicator-styles-current-day'
}).withConfig({
  displayName: "CurrentTimeIndicatorStyles__CurrentTimeIndicatorStylesCurrentDay",
  componentId: "n73ffr-0"
})(["background:", ";height:2px;position:absolute;top:", ";width:100%;z-index:999;&::before{background:inherit;border-radius:100px;content:'';display:block;height:10px;left:-5px;position:absolute;top:-5px;width:10px;}"], ({
  theme
}) => theme.color['fill-alert-default'], ({
  top
}) => `${top}px`);
export const CurrentTimeIndicatorStyles = styled.div.attrs({
  'data-test-id': 'current-time-indicator-styles'
}).withConfig({
  displayName: "CurrentTimeIndicatorStyles",
  componentId: "n73ffr-1"
})(["height:1px;position:absolute;top:", ";width:100%;z-index:999;border:", ";"], ({
  top
}) => `${top}px`, ({
  theme: {
    color,
    borderWidth
  }
}) => `${borderWidth['100']} dashed ${color['border-core-subtle']}`);